/**
 * @file Newsletter Form
 */

import { getAjaxUrl } from "../Utils";

const NewsletterForm = {
  /**
   * Initializes the Swiper
   */
  init() {
    document.querySelectorAll(".newsletter-form").forEach(function (form) {
      // Add event listener to the form submit event
      form.addEventListener("submit", function (event) {
        // Prevent the default form submission
        event.preventDefault();

        const newsletterMessage = form
          .closest(".wbcsd-newsletter-form")
          .querySelector(".newsletter-message");

        const ajaxUrl = getAjaxUrl();
        const tags = form.dataset?.tags || "";

        // Get the form data
        const formData = new FormData(form);

        formData.append("action", "newsletter_subscribe");
        formData.append("tags", tags);

        fetch(ajaxUrl, {
          method: "POST",
          body: formData,
        })
          .then((response) => response.json())
          .then(({ data, success }) => {
            newsletterMessage.textContent = data;
            newsletterMessage.classList.remove("hidden");

            if (success) {
              form.reset();
              form.classList.add("hidden");
            }
          })
          .catch((error) =>
            console.error("Error sending newsletter subscription", error)
          );
      });
    });
  },
};

export default NewsletterForm;
